module.exports = __webpack_public_path__ + "fannieBubble.3JN1loHV.png";